import appGlobalScript from '/opt/atlassian/pipelines/agent/build/core/src/global/larva-global.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
